import { createSlice } from '@reduxjs/toolkit';

const selectedStudioSlice = createSlice({
  name: 'selectedStudio',
  initialState: {
    studio: null,
    filteredStudio: null,
  },
  reducers: {
    setSelectedStudio: (state, action) => {
      state.studio = action.payload;
      state.filteredStudio = action.payload;
    },
    resetSelectedStudio: (state) => {
      state.studio = null;
      state.filteredStudio = null;
    }
  },
});

export const {
  setSelectedStudio,
  resetSelectedStudio
} = selectedStudioSlice.actions;

export default selectedStudioSlice.reducer;
